import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CouponSearchRequestBody, CouponSearchResponse } from "./types";

export class CouponSearchAPI extends BaseAPI<
  CouponSearchRequestBody,
  CouponSearchResponse
> {
  protected route = ApiRoutes.coupon.search;
  protected method = RequestMethod.POST;
}
